export default class RegistrationRequest {

    public email: string = ''
    public password: string = ''
    public confirmPassword: string = ''
    public role: string = ''
}
